import '../style/error-panel-C3qR5oXG.css'
import { defineComponent as y, reactive as v, computed as N, onMounted as w, openBlock as a, createElementBlock as i, renderSlot as g, createElementVNode as p, createVNode as l, unref as c, withCtx as u, Fragment as k, renderList as K, toDisplayString as M, withKeys as S, withModifiers as C, createTextVNode as x } from "vue";
import b from "./icon.js";
import { AccordionItem as B } from "./accordion.js";
import { Button as $ } from "./button.js";
import { MessageFn as E } from "./message.js";
import { useGlobalEmitter as I } from "./hooks/useGlobalEmitter.js";
const T = { class: "e-error-panel" }, V = {
  key: 1,
  class: "e-error-panel-content-wrapper"
}, z = { class: "e-error-panel-content" }, D = /* @__PURE__ */ p("p", { class: "e-error-panel-title" }, " Sorry, we encounter an issue when loading the data. ", -1), F = ["onKeydown"], q = /* @__PURE__ */ y({
  name: "e-error-panel",
  __name: "error-panel",
  props: {
    routeKey: {},
    errorNames: {}
  },
  setup(d) {
    const o = d, e = v({
      errorsMap: {},
      errors: [],
      errorNames: []
    }), t = I(), s = N(() => e.errorNames.length === 0 ? null : {
      names: e.errorNames,
      details: e.errorNames.map((r) => e.errorsMap[r]?.details).flat()
    }), f = () => {
      s.value && (t.emit("report", {
        routeKey: o.routeKey,
        data: e.errors,
        reportTime: Math.floor(Date.now() / 1e3)
      }), E({
        type: "warning",
        title: "Reported Issue",
        description: "Thank you! Our team will prioritize to resolve the issue you have reported."
      }));
    }, m = () => {
      s.value && t.emit("contact-cs", {
        from: "issue",
        routeKey: o.routeKey,
        data: e.errors
      });
    };
    return w(() => {
      t.on("error", (r) => {
        o.errorNames.includes(r.name) && (e.errorsMap[r.name] = r, e.errorNames.includes(r.name) || (e.errorNames.push(r.name), e.errors.push(r)));
      }), t.on("clear-error", (r) => {
        o.errorNames.includes(r) && (e.errorsMap[r] = null, e.errorNames = e.errorNames.filter((n) => n !== r), e.errors = e.errors.filter((n) => n.name !== r));
      });
    }), (r, n) => (a(), i("div", T, [
      s.value ? (a(), i("div", V, [
        p("div", z, [
          l(c(b), {
            icon: "doc-badge-cross-circle",
            color: "var(--text-danger)",
            size: 40
          }),
          D,
          l(c(B), {
            title: "See details",
            icon: "caret-down",
            "icon-color": "var(--common-tertiary)"
          }, {
            default: u(() => [
              (a(!0), i(k, null, K(s.value.details, (_, h) => (a(), i("p", {
                key: h,
                class: "e-error-panel-detail-item"
              }, M(_), 1))), 128))
            ]),
            _: 1
          }),
          p("p", {
            class: "e-error-panel-contact",
            role: "button",
            tabindex: "0",
            onClick: m,
            onKeydown: S(C(m, ["stop", "prevent"]), ["space", "enter"])
          }, " Contact Support ", 40, F),
          l(c($), {
            "color-scheme": "plain",
            outline: "",
            onClick: f
          }, {
            default: u(() => [
              x(" Report issue ")
            ]),
            _: 1
          })
        ])
      ])) : g(r.$slots, "default", { key: 0 })
    ]));
  }
});
export {
  q as default
};
//# sourceMappingURL=error-panel.js.map
